<template>
  <el-menu-item @click="goTo">
    <slot />
  </el-menu-item>
</template>

<script>
  export default {
    props: {
      url: String
    },

    methods: {
      goTo() {
        window.location.href = this.url
      }
    }
  }
</script>

<style scoped>

</style>